import map from '../apiToDictMap';

const PLACEHOLDER_START = '{{';
const R_REPLACE = /{{(.+?)}}/g;
const EMPTY = '';

const getDictKey = (key) => {
    return map[key] || key;
};

const replaceKeys = (match, key) => {
    return replacementHolder[key]?.toString() || match; // toString() added so that it will correctly return number 0. Scores, hits, errors, etc.
};

let replacementHolder = {};

/**
 * Retrieve a translation, by key, from a dictionary map.
 * @param  {object} dict        Key/value pair map of dictionary translations.
 * @param  {string} key         Key to retrieve.
 * @param  {[string]} fallback  Optional fallback text, in the event key is undefined.
 * @param  {[object]} replaceWith Optional replacement map of placeholder key/values. (ex: {{name}})
 * @return {string}             Translated value with placeholders resolved.
 */
const getTranslation = (dict = {}, key, fallback, replaceWith) => {
    const dictKey = getDictKey(key);
    let dictionaryItem = dict[dictKey] ? dict[dictKey] : (fallback || EMPTY);
    const isReplacementRequired = replaceWith && dictionaryItem.indexOf(PLACEHOLDER_START) >= 0;

    if (isReplacementRequired && dictionaryItem) {
        replacementHolder = replaceWith;
        dictionaryItem = dictionaryItem.replace(R_REPLACE, replaceKeys);
        replacementHolder = {};
    }

    return dictionaryItem;
};

export default getTranslation;
